export default __webpack_public_path__ + "static/media/home-creative-agency-bg-img-02.f56bc03d.jpg";